export function compareOp(value1, operator, value2) {
    value1 = parseFloat(value1);
    value2 = parseFloat(value2);

    switch (operator) {
        case "=":
        case "==":
        case "===":
            return value1 === value2;

        case "!=":
        case "!==":
            return value1 !== value2;

        case "<":
            return value1 < value2;

        case "<=":
            return value1 <= value2;

        case ">":
            return value1 > value2;

        case ">=":
            return value1 >= value2;

        default:
            return undefined;
    }
}
